import { InterventionStates } from '../../generated/graphql';
import { FilterProps } from '../../types/types';
import { enumToOptions } from '../../utils/filters';
import SelectEnumFilter from '../SelectEnumFilter/SelectEnumFilter';

export default function InterventionStateFilter(props: FilterProps) {
    const { value, onChange } = props
    const options = enumToOptions(InterventionStates)
    return (
        <SelectEnumFilter
            value={value}
            onChange={onChange}
            label="Estado"
            field="state"
            multiple
            options={options}
        />
    )
}
